import { Stack } from '@mui/material';

import { ButtonWithPopover } from '@/components/form/baseInputs/Button/ButtonWithPopover';
import { Checkbox } from '@/components/form/baseInputs/Checkbox';
import { CheckboxListWrapper } from '@/components/form/formAwareInputs/FormAwareCheckboxList/FormAwareCheckboxList';
import { Settings04Icon } from '@/components/icons/Settings04Icon';
import { COLORS } from '@/styles/tokens/colors';

import { useFamilyTreeContext } from '../contexts';

export const FamilyTreeVizConfigSettings = () => {
  const { state, dispatch } = useFamilyTreeContext();
  const { visualizationConfig } = state;

  function updateConfigValue(
    key:
      | 'showAge'
      | 'showHiddenIndividuals'
      | 'showNotes'
      | 'showStateOfResidence'
  ) {
    return () => {
      dispatch({
        type: 'UPDATE_VISUALIZATION_CONFIG',
        key,
        value: !visualizationConfig[key],
      });
    };
  }

  return (
    <ButtonWithPopover
      keepOpen
      label="Settings"
      size="sm"
      variant="secondary"
      buttonSx={{
        backgroundColor: COLORS.PRIMITIVES.WHITE,
        margin: 0,
      }}
      hideChevron
      popperProps={{
        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
        transformOrigin: { horizontal: 'left', vertical: 0 },
      }}
      startIcon={Settings04Icon}
    >
      <Stack paddingX={1}>
        <CheckboxListWrapper>
          <Checkbox
            value={!!visualizationConfig?.showAge}
            label="Show age"
            onChange={updateConfigValue('showAge')}
          />
          <Checkbox
            value={!!visualizationConfig?.showStateOfResidence}
            label="Show state of residence"
            onChange={updateConfigValue('showStateOfResidence')}
          />
          <Checkbox
            value={!!visualizationConfig?.showHiddenIndividuals}
            label="Show hidden individuals"
            onChange={updateConfigValue('showHiddenIndividuals')}
          />
          <Checkbox
            value={!!visualizationConfig?.showNotes}
            label="Show notes for all"
            onChange={updateConfigValue('showNotes')}
          />
        </CheckboxListWrapper>
      </Stack>
    </ButtonWithPopover>
  );
};
